module.exports = __webpack_public_path__ + "img/Video.353747e6.svg";